import Route from '@ember/routing/route'
import { service } from '@ember/service'
import RSVP from 'rsvp'
import type { StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type { NormalizedInterval } from 'date-fns'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export class BooksReadByLevelRexRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductRex = 'rex'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return {
      uiScope,
      scopedStudents: scopedData.students,
      ...stats,
    }
  }

  makeStatsRequests = async (product: LegacyProductRex, scope: StudentsScope, period: NormalizedInterval) => {
    const { studentEvents } = this
    return RSVP.hash({
      booksReadByLevelTotals: studentEvents.booksReadByLevelTotals(product, scope, period),
      booksReadByLevelHistory: studentEvents.booksReadByLevelHistory(product, scope, period),
    })
  }
}

export default BooksReadByLevelRexRoute
